export default "__VITE_ASSET__ca41300e__"